import { memo } from "react";

export const Page401 = memo(() => {
  return <p>401ページ</p>;
});
